import { useState, useEffect } from "react";
import { apiGet, errorMessage } from "./api";
import "./MyAccount.css";

const INVOICE_STATUS = {
  paid: "Payée",
  open: "En attente",
  void: "Annulée",
  uncollectible: "Irrécouvrable",
};

// Factures du commerce du gérant connecté. Le serveur ne renvoie que celles
// de son organisation : il n'y a pas de filtre à poser côté client.
// Partagé entre la page Mon compte et la page Facturations du menu.
function InvoicesPanel() {
  const [invoices, setInvoices] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    apiGet("/api/billing/invoices", "Impossible de charger vos factures")
      .then((data) => setInvoices(data.invoices))
      .catch((e) => setError(errorMessage(e, "Impossible de charger vos factures")));
  }, []);

  return (
    <div className="acct-panel">
      <h3>Vos factures</h3>
      {error ? (
        <div className="acct-error">{error}</div>
      ) : invoices === null ? (
        <p className="acct-inv-empty">Chargement...</p>
      ) : invoices.length === 0 ? (
        <p className="acct-inv-empty">
          Aucune facture pour le moment — elles apparaîtront ici après votre
          premier prélèvement.
        </p>
      ) : (
        <div className="acct-inv-scroll">
          <table className="acct-inv-table">
            <thead>
              <tr>
                <th>Émise le</th>
                <th>Numéro</th>
                <th>Offre</th>
                <th className="acct-inv-num">Montant</th>
                <th>Statut</th>
                <th><span className="acct-sr-only">Document</span></th>
              </tr>
            </thead>
            <tbody>
              {invoices.map((inv) => (
                <tr key={inv.number || inv.created}>
                  <td>
                    {new Date(inv.created * 1000).toLocaleDateString("fr-FR", {
                      day: "2-digit", month: "2-digit", year: "numeric",
                    })}
                  </td>
                  <td className="acct-inv-mono">{inv.number || "—"}</td>
                  <td>
                    {inv.plan_label || "—"}
                    {inv.billing && (
                      <span className="acct-inv-billing">
                        {inv.billing === "monthly" ? " · mensuel" : " · annuel"}
                      </span>
                    )}
                  </td>
                  <td className="acct-inv-num">
                    {inv.total.toLocaleString("fr-FR", { minimumFractionDigits: 2 })} €
                  </td>
                  <td>
                    <span className={`acct-inv-status acct-inv-status-${inv.status}`}>
                      {INVOICE_STATUS[inv.status] || inv.status}
                    </span>
                  </td>
                  <td>
                    {inv.pdf && (
                      <a className="acct-inv-link" href={inv.pdf}
                         target="_blank" rel="noopener noreferrer">
                        PDF
                      </a>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default InvoicesPanel;
